import AboutJob from "./AboutJob";
import JobOpening from "./JobOpening";

const AboutAndJobOpening = () => {
  return (
    <div className="overflow-hidden">
      <AboutJob />
      <JobOpening />
    </div>
  );
};

export default AboutAndJobOpening;
